/* eslint-disable no-restricted-syntax */
/* eslint-disable max-len */
/* eslint-disable class-methods-use-this */
/* eslint-disable max-classes-per-file */
import {
  CatalogFileCollection,
  CatalogFileCollectionObject,
  CatalogFileCollectionObjectInfo,
  CatalogFileCollectionObjectTag,
  CatalogFileRoot,
  PriceData,
  PriceDataHelpers,
} from '../../fileFormats/catalog/catalog';

import {
  SLTXFormatRootFile,
  SLTXFormatRootFileGroup,
  SLTXFormatRootFileVariant,
} from '../../fileFormats/sltx/sltx';

import { FilePaths } from '../../fileSystem/filePaths';
import { TreeOptionSelections } from '../../modelConfiguration/data/optionsSelection';
import { CatalogTagsTranslation } from './catalogTagsTranslation';

import { CustomizationConfiguration } from './CustomizationConfiguration';

export class POSCatalogModelData {

  // Info form the model file
  data : SLTXFormatRootFile | undefined;

  // A copy of the info inside the catalog file
  // (This helps to keep all the model info in one place)
  catalogData : CatalogFileCollectionObject | undefined;

  // Info from customizations file
  customizations : CustomizationConfiguration | undefined;

  public getName() : string {
    if (this.catalogData) {
      return this.catalogData.name;
    }

    return '';
  }

  public getPrice(priceData: PriceData[] | undefined) : number {
    const catalogPrice = priceData ? PriceDataHelpers.getPrice(priceData, this.getName()) : undefined;
    if (catalogPrice) return catalogPrice;

    if (this.catalogData) {
      return Number(this.catalogData.price);
    }
    return 0;
  }

  public getPriceCurrency() : number {
    if (this.catalogData) {
      return this.catalogData.priceCurrency;
    }
    return 0;
  }

  public getInfo() : CatalogFileCollectionObjectInfo[] {
    if (this.catalogData) {
      return this.catalogData.objectInfo;
    }
    return [];
  }

  public getFileInfoPath() : string {
    if (this.catalogData) {
      return this.catalogData.infoRef;
    }
    return '';
  }

  public hasVariants() : boolean {

    if (this.data
      && this.data.variants
      && (this.data.variants.length > 0)) {
      return true;
    }
    return false;
  }

  public getVariants() : SLTXFormatRootFileVariant[] {

    if (this.data
      && this.data.variants) {
      return this.data.variants;
    }

    return [];
  }

  public getVariantByName(
    variantName : string,
  ) : SLTXFormatRootFileVariant | undefined {

    if (this.data === undefined
      || this.data.variants === undefined) {
      return undefined;
    }

    return this.data.variants.find(
      (variant) => variant.name === variantName,
    );
  }

  public hasConfigurableGroups() : boolean {
    if (this.data
      && this.data.groups
      && this.data.groups.length > 0) {
      return true;
    }
    return false;
  }

  public getResourcesPath() : string {

    if (this.catalogData === undefined) {
      return '';
    }

    return FilePaths.splitFileFromPath(this.catalogData.infoRef)[0];
  }

  public getGroups(): SLTXFormatRootFileGroup[] {
    if (this.data && this.data.groups) {
      return this.data.groups;
    }
    return [];
  }

  public getObjects() : string {

    if (this.data) {
      return this.data.objects;
    }

    return '';
  }

  public getCustomizations() : CustomizationConfiguration | undefined {
    if (this.customizations) {
      return this.customizations;
    }
    return undefined;
  }

  public getTags() : CatalogFileCollectionObjectTag[] {

    if (this.catalogData === undefined) {
      return [];
    }

    return this.catalogData.tags;
  }

  static GetVariantDescription(
    currentVariant : TreeOptionSelections,
    objectVariants : Array<SLTXFormatRootFileVariant>,
  ): string {

    for (let curVariant = 0; curVariant < objectVariants.length; curVariant++) {
      const variant = objectVariants[curVariant];

      let bMismatchFound = false;

      // Go through all the options of this variant
      const { variantComposition } = variant;

      for (
        let curVariantGroup = 0;
        curVariantGroup < variantComposition.length;
        curVariantGroup++
      ) {
        const variantGroupId = variantComposition[curVariantGroup].groupId;
        const variantOptionId = variantComposition[curVariantGroup].optionId;

        // Check the current selection matches this optionId

        const currentConfigGroup = currentVariant.find(
          (configGroup) => configGroup.groupID === variantGroupId,
        );

        if (currentConfigGroup === undefined) {
          bMismatchFound = true;
          break;
        }

        if (currentConfigGroup.optionID !== variantOptionId) {
          bMismatchFound = true;
          break;
        }
      }

      if (bMismatchFound === false) {
        return variant.name;
      }
    }

    return '';
  }

  public setRulesTranslation(tagsTranslations : CatalogTagsTranslation[]) {

    // -----------------------------------------------------------------
    // First let's filter tags that are for this model and domain rules
    // -----------------------------------------------------------------
    const modelRulesTrans = tagsTranslations.filter((tag) => {
      const optParts = tag.option?.split('/');
      if (optParts === undefined
        || optParts.length <= CatalogTagsTranslation.TAG_DOMAIN) return false;
      return (
        (
          optParts[CatalogTagsTranslation.TAG_TYPE] === 'domain'
          || optParts[CatalogTagsTranslation.TAG_TYPE] === 'domain-group'
        ) && (
          optParts[CatalogTagsTranslation.TAG_MODEL] === this.getName()
        )
      );
    }); // end tagsTranslations.filter()

    // -----------------------------------------------------------------
    // Set the tag for all rules that are Domain Rules
    // -----------------------------------------------------------------
    this.catalogData?.rules.forEach((rule) => {
      if (!rule.ruleDataDomain) return;

      // --------------------------------------------------------
      // Filter the tags that are for this rule
      // --------------------------------------------------------
      const ruleTags = modelRulesTrans.filter((tag) => {
        const optParts = tag.option?.split('/');
        if (optParts === undefined
          || optParts.length <= CatalogTagsTranslation.TAG_DOMAIN) return false;
        return (
          (
            optParts[CatalogTagsTranslation.TAG_TYPE] === 'domain'
            || optParts[CatalogTagsTranslation.TAG_TYPE] === 'domain-group'
          ) && (
            optParts[CatalogTagsTranslation.TAG_DOMAIN] === rule.name
          )
        );
      }); // end filter tags for this domain

      // --------------------------------------------------------
      // Set the tag for this Domain Rule
      // --------------------------------------------------------
      // eslint-disable-next-line no-param-reassign
      rule.ruleDataDomain.tagTranslation = ruleTags.find((tag) => {
        return tag.option?.split('/')[CatalogTagsTranslation.TAG_TYPE] === 'domain';
      });

      // --------------------------------------------------------
      // Set the tag for all children domain-groups
      // --------------------------------------------------------
      rule.ruleDataDomain.domainGroups.forEach((dGroup) => {
        // eslint-disable-next-line no-param-reassign
        dGroup.tagTranslation = ruleTags.find((tag) => {
          const optParts = tag.option?.split('/');
          if (optParts === undefined
            || optParts.length <= CatalogTagsTranslation.TAG_DOMAIN_GROUP) return false;
          return (
            (
              optParts[CatalogTagsTranslation.TAG_TYPE] === 'domain-group'
            ) && (
              optParts[CatalogTagsTranslation.TAG_DOMAIN_GROUP] === dGroup.name
            )
          );
        }); // end rule.ruleDataDomain.domainGroups.forEach((dGroup)
      }); // this.catalogData?.rules.forEach((rule)
    });
  }
}

export class POSCatalogData {
  // Information that comes form the catalog file
  catalogFileInfo : CatalogFileRoot | undefined;

  // File loaded for each model
  modelsData : Map<string, POSCatalogModelData> = new Map<string, POSCatalogModelData>();

  public getModelByCollectionIDAndModelID(
    collectionID : number,
    modelID : number,
  ) : POSCatalogModelData | undefined {

    // Locate the the collection in the catalog
    if (this.catalogFileInfo === undefined) {
      return undefined;
    }

    const catalogCollectionData = this.catalogFileInfo.collections.find(
      (c) => c.id === collectionID,
    );

    if (catalogCollectionData === undefined) {
      // Cannot find a collection with this ID
      return undefined;
    }

    const catalogModelData = catalogCollectionData.objects.find((o) => o.id === modelID);
    if (catalogModelData === undefined) {
      return undefined;
    }

    // We found the original model in the catalog data.
    // Use that key to retrieve all the info about the model
    const modelKey = catalogModelData.versionControl.key;

    return this.modelsData.get(modelKey);
  }

  public getModelByCollectionIDAndModelName(
    collectionID : number,
    modelName : string,
  ) : POSCatalogModelData | undefined {

    // Locate the the collection in the catalog
    if (this.catalogFileInfo === undefined) {
      return undefined;
    }

    const catalogCollectionData = this.catalogFileInfo.collections.find(
      (c) => c.id === collectionID,
    );

    if (catalogCollectionData === undefined) {
      // Cannot find a collection with this ID
      return undefined;
    }

    const catalogModelData = catalogCollectionData.objects.find((o) => o.name === modelName);
    if (catalogModelData === undefined) {
      return undefined;
    }

    // We found the original model in the catalog data.
    // Use that key to retrieve all the info about the model
    const modelKey = catalogModelData.versionControl.key;
    return this.modelsData.get(modelKey);
  }

  public getModelByCollectionNameAndModelName(
    collectionName : string,
    modelName : string,
  ) : POSCatalogModelData | undefined {

    // Locate the the collection in the catalog
    if (this.catalogFileInfo === undefined) {
      return undefined;
    }

    const catalogCollectionData = this.catalogFileInfo.collections.find(
      (c) => c.name === collectionName,
    );

    if (catalogCollectionData === undefined) {
      // Cannot find a collection with this ID
      return undefined;
    }

    const catalogModelData = catalogCollectionData.objects.find((o) => o.name === modelName);
    if (catalogModelData === undefined) {
      return undefined;
    }

    // We found the original model in the catalog data.
    // Use that key to retrieve all the info about the model
    const modelKey = catalogModelData.versionControl.key;
    return this.modelsData.get(modelKey);
  }

  public getModelBylName(
    modelName : string,
  ) : POSCatalogModelData | undefined {

    // Locate the the collection in the catalog
    if (this.catalogFileInfo === undefined) {
      return undefined;
    }

    // Let's search for the first collection with a model with that name
    // Note that a model's name MUST be unique in the catalog
    for (const catalogCollectionData of this.catalogFileInfo.collections) {
      if (catalogCollectionData === undefined) continue;
      const catalogModelData = catalogCollectionData.objects.find((o) => o.name.toLocaleLowerCase() === modelName.toLocaleLowerCase());
      if (catalogModelData === undefined) continue;

      // We found the original model in the catalog data.
      // Use that key to retrieve all the info about the model
      const modelKey = catalogModelData.versionControl.key;
      return this.modelsData.get(modelKey);
    }
    return undefined;
  }

  public getCollections() : CatalogFileCollection[] {
    if (this.catalogFileInfo === undefined) {
      return [];
    }

    return this.catalogFileInfo.collections;

  }

}
